import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="customer";
export function queryByName(parameter) {
    return axios({
    url: `/ws/${moduleName}/queryByName`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getCustomerRelationShipOptions(){
  return axios({
    url: `/ws/datadict/getDatadictChildsByPath/system.business_key.cms`,
    method: 'get',
  })
}

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectMyAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectMyAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function queryStatistics(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function getColumnACustomerFollower(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/getColumnACustomerFollower/${id}`,
    method: 'get',
  })
}

export function selectByUpdateReasonId(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/selectByUpdateReasonId/${id}`,
    method: 'get',
  })
}

export function updateAttribute(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateAttribute`,
    method: 'put',
    data:parameter
  })
}

/**
 * 查询客户关系变更记录
 * @param id
 * @returns {AxiosPromise}
 */
export function selectChangeInfo(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/selectChangeInfo/${id}`,
    method: 'get',
  })
}

export function changeCustomerRelationship(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/changeCustomerRelationship`,
    method: 'post',
    params:parameter
  })
}

export function addMyCustoner(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/addMyCustoner`,
    method: 'post',
    params:parameter
  })
}

export function deleteCustomerAccount(customerId){
  console.log("data:",customerId)
  return axios({
    url: `/ws/${moduleName}/deleteCustomerAccount`,
    method: 'delete',
    params: {customerId:customerId},
  })
}


export default {
  changeCustomerRelationship,
  addMyCustoner,
  deleteCustomerAccount,
  insert,
  update,
  selectMyAll,
  selectAll,
  selectByUpdateReasonId,
  selectOne,
  updateAttribute,
  queryByName,
  getCustomerRelationShipOptions,
  queryStatistics,
  getColumnACustomerFollower,
  selectChangeInfo,
}